<template>
  <article class="member-signup">
    <section id="passwordLinkExpired" class="center">
      <h2>{{passExpirationLabel_1}}</h2>
      <p>
        <iron-icon icon="nuskin:icon-broken-link" class="icon-5x"></iron-icon>
      </p>
      <p>{{passExpirationLabel_2}}</p>
      <p>{{passExpirationLabel_3}}</p>
    </section>

    <section>
      <ns-button
        flat
        block
        class="primary-hit mb-2 fluid"
        @click="handlePasswordExpired"
      >{{resetPassBtnText}}</ns-button>
    </section>
  </article>
</template>

<script>
export default {
  name: "PasswordLinkExpired",
  props: {
    /**
     * The label text for the password expired text label 1
     */
    passExpirationLabel_1: {
      type: String,
      default: "OOPS!"
    },
    /**
     * The label text for the password expired text label 2
     */
    passExpirationLabel_2: {
      type: String,
      default: "Sorry."
    },
    /**
     * The label text for the password expired text label 3
     */
    passExpirationLabel_3: {
      type: String,
      default: "Your password reset link has expired."
    },
    /**
     * The text displayed on the button in the reset password view
     */
    resetPassBtnText: {
      type: String,
      default: "Continue"
    },
    forgotPassHref: {
      type: String,
      value: "#forgot-password"
    }
  },
  methods: {
    handlePasswordExpired() {
      this.$router.push({
        name: "forgot-password"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
